'use client';

import { useSearchParams } from 'next/navigation';
import * as yup from 'yup';
import GenericPage, {
	IGenericPageProps,
} from '../../../app/pages/ui/GenericPage';
import { IFlightsEnrichmentData } from '../../shared/flight/domain/models/IEnrichedFlight';
import { FlightListScope } from '../domain/constants/FlightListScope';
import { FlightStoresProvider } from '../../shared/context/flightStoresContext';
import { useSetFlightsEnrichmentData } from '../../shared/flight/ui/useSetFlightsEnrichmentData';
import { FlightsPageContent } from './FlightsPageContent';
import { getCurrentAirportCodeFromId } from '../../../../components/common/navigation/utils/getCurrentAirportCode';
import { ISiteSectionEntry } from '../../../../contentful/types/ISiteSection';

interface IFlightPageProps extends IGenericPageProps {
	flightsEnrichmentData: IFlightsEnrichmentData;
	siteSection?: ISiteSectionEntry;
}

const querySchema = yup.string().optional();
const scopeSchema = yup
	.mixed<FlightListScope>()
	.oneOf(Object.values(FlightListScope));

export default function FlightsPage({
	page,
	flightsEnrichmentData,
	siteSection,
}: IFlightPageProps) {
	useSetFlightsEnrichmentData(flightsEnrichmentData);
	const { parent } = page.fields;
	const currentAirportCode = getCurrentAirportCodeFromId(parent?.fields.id);
	const searchParams = useSearchParams();

	const params = {
		query: searchParams.get('query'),
		scope: searchParams.get('scope'),
	};

	const query = querySchema.isValidSync(params.query)
		? params.query
		: undefined;

	const scope = scopeSchema.isValidSync(params.scope)
		? params.scope
		: undefined;

	return (
		<FlightStoresProvider query={query} scope={scope}>
			<GenericPage page={page} siteSection={siteSection}>
				<FlightsPageContent
					airport={currentAirportCode}
					paramsScope={scope}
					flightsEnrichmentData={flightsEnrichmentData}
				/>
			</GenericPage>
		</FlightStoresProvider>
	);
}
